var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';
import { SET_STDPC_SELECT, SET_PRODUCT_SELECT } from '../../../reducers/product';
import { addCart } from '../../../utils/add_cart';
import Count from './count';
import { gaAddCartItemProcess } from '../../libs/googleTagmanager';
var LowButton = function (_a) {
    var idx_b_manager = _a.idx_b_manager, item_id = _a.item_id, userInfo = _a.userInfo, isStdpc = _a.isStdpc;
    var stdpcSelect = useSelector(function (state) { return state.product.stdpcSelect; });
    var productSelect = useSelector(function (state) { return state.product.productSelect; });
    var item = useSelector(function (state) { return state.product.item; });
    var stdpcOption = useSelector(function (state) { return state.product.stdpcOption; });
    var stdpcType = stdpcSelect.stdpc_item_list_type1;
    var stdpcType2 = stdpcSelect.stdpc_item_list_type2;
    var stdpcType3 = stdpcSelect.stdpc_item_list_type3;
    var stdpcType4 = stdpcSelect.stdpc_item_list_type4;
    var dispatch = useDispatch();
    var cartData = {
        count: isStdpc ? stdpcSelect.each : productSelect.each,
        userInfo: userInfo,
        idx_b_manager: idx_b_manager,
        item_id: item_id,
        dispatch: dispatch,
        stdpcType: stdpcType,
        stdpcType2: stdpcType2,
        stdpcType3: stdpcType3,
        stdpcType4: stdpcType4,
        opt: false
    };
    var changeCount = function (num) {
        dispatch({
            type: isStdpc ? SET_STDPC_SELECT : SET_PRODUCT_SELECT,
            payload: {
                each: num
            }
        });
    };
    var onClickCart = function () {
        var stdpcData = stdpcSelect.selectIdxArr;
        addCart(__assign(__assign({}, cartData), { opt: false, stdpcData: stdpcData }));
        if (item && userInfo) {
            gaAddCartItemProcess(item, cartData, stdpcOption);
        }
    };
    var onClickBuy = function () {
        var stdpcData = stdpcSelect.selectIdxArr;
        addCart(__assign(__assign({}, cartData), { opt: true, stdpcData: stdpcData }));
        if (item && userInfo) {
            gaAddCartItemProcess(item, cartData, stdpcOption);
        }
    };
    return (React.createElement(Style, null,
        React.createElement(Count, { count: isStdpc ? stdpcSelect.each : productSelect.each, setCount: changeCount }),
        React.createElement("button", { type: "button", className: "button cart_add", onClick: onClickCart },
            React.createElement("span", { className: "txt" }, "\uC7A5\uBC14\uAD6C\uB2C8 \uB2F4\uAE30")),
        React.createElement("button", { type: "button", className: "button buy_now", onClick: onClickBuy },
            React.createElement("span", { className: "txt" }, "\uBC14\uB85C \uAD6C\uB9E4\uD558\uAE30"))));
};
var Style = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n\n    .button {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        border: 1px solid #418ded;\n        width: 170px;\n        height: 40px;\n        font-weight: 700;\n    }\n    .cart_add {\n        margin: 0 0 0 12px;\n        background: #fff;\n        color: #418ded;\n\n        &:hover {\n            background: #f7f7fa;\n        }\n    }\n    .buy_now {\n        margin: 0 0 0 12px;\n        background: #418ded;\n        color: #fff;\n\n        &:hover {\n            background: #3281ed;\n        }\n    }\n"], ["\n    display: flex;\n\n    .button {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        border: 1px solid #418ded;\n        width: 170px;\n        height: 40px;\n        font-weight: 700;\n    }\n    .cart_add {\n        margin: 0 0 0 12px;\n        background: #fff;\n        color: #418ded;\n\n        &:hover {\n            background: #f7f7fa;\n        }\n    }\n    .buy_now {\n        margin: 0 0 0 12px;\n        background: #418ded;\n        color: #fff;\n\n        &:hover {\n            background: #3281ed;\n        }\n    }\n"])));
export default LowButton;
var templateObject_1;



//////////////////
// WEBPACK FOOTER
// ./src/detail/components/summary_info/detail/low_button.tsx
// module id = 212
// module chunks = 0